import axios from 'axios';

const api = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/api/auth/login', { email, password });
export const getMe = () => api.get('/api/auth/me');
export const changePassword = (currentPassword, newPassword) => 
  api.put('/api/auth/password', { current_password: currentPassword, new_password: newPassword });

// Users
export const getUsers = () => api.get('/api/users');
export const createUser = (data) => api.post('/api/users', data);
export const updateUser = (userId, data) => api.put(`/api/users/${userId}`, data);
export const deleteUser = (userId) => api.delete(`/api/users/${userId}`);
export const resetUserPassword = (userId, newPassword) => api.put(`/api/users/${userId}/reset-password`, { new_password: newPassword });
export const getTeamUsers = (team) => api.get(`/api/users/team/${encodeURIComponent(team)}`);

// Accounts
export const getAccounts = (params) => api.get('/api/accounts', { params });
export const getAccount = (accountId) => api.get(`/api/accounts/${accountId}`);
export const createAccount = (data) => api.post('/api/accounts', data);
export const updateAccount = (accountId, data) => api.put(`/api/accounts/${accountId}`, data);
export const deleteAccount = (accountId) => api.delete(`/api/accounts/${accountId}`);

// Devices
export const addDevice = (accountId, data) => api.post(`/api/accounts/${accountId}/devices`, data);

// Blockers
export const addBlocker = (accountId, data) => api.post(`/api/accounts/${accountId}/blockers`, data);
export const updateBlocker = (accountId, blockerId, data) => api.put(`/api/accounts/${accountId}/blockers/${blockerId}`, data);

// Hand-off
export const handOffAccount = (accountId) => api.post(`/api/accounts/${accountId}/handoff`);
export const markCompleted = (accountId) => api.post(`/api/accounts/${accountId}/complete`);

// Notes
export const addNote = (accountId, content) => api.post(`/api/accounts/${accountId}/notes`, { content });

// Tasks
export const getTasks = (params) => api.get('/api/tasks', { params });
export const updateTask = (taskId, completed) => api.put(`/api/tasks/${taskId}`, { completed });

// Dashboard
export const getDashboardSummary = () => api.get('/api/dashboard/summary');
export const getPendingApprovals = () => api.get('/api/dashboard/approvals');

// Reports
export const getAccountsByStatus = () => api.get('/api/reports/accounts-by-status');
export const getAccountsByLevel = () => api.get('/api/reports/accounts-by-level');
export const getBlockerFrequency = () => api.get('/api/reports/blocker-frequency');
export const getCompletedOverTime = () => api.get('/api/reports/completed-over-time');
export const getStaleHistory = () => api.get('/api/reports/stale-history');

// Automation Logs
export const getAutomationLogs = (limit = 100) => api.get('/api/automation-logs', { params: { limit } });

export default api;
